import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs';
import {PermissionService} from '@shared/service/permission.service';
import {Location} from '@angular/common';

@Injectable()
export class InnerMessagesService {
	protected pushInnerMessagesSubject: Subject<InnerMessage> = new Subject<InnerMessage>();
	pushInnerMessagesObservable: Observable<InnerMessage> = this.pushInnerMessagesSubject.asObservable();

	protected removeInnerMessagesSubject: Subject<string> = new Subject<string>();
	removeInnerMessagesObservable: Observable<string> = this.removeInnerMessagesSubject.asObservable();


	constructor(private permissionService: PermissionService,
		private location: Location) {
	}

	pushInnerMessage(innerMessage: InnerMessage): void {
		this.pushInnerMessagesSubject.next(innerMessage);
	}

	removeInnerMessage(idInnerMessage: string): void {
		this.removeInnerMessagesSubject.next(idInnerMessage);
	}

	deleteAll(): void {
		this.removeInnerMessagesSubject.next(InnerMessage.DELETE_ALL);
	}
}

/**
 * type
 * success => verde
 * error => rosso
 * warning => giallo
 * info => azzurro
 */
/**
 * id
 * DELETE_ALL = 0 interno per cancellare tutti i mex
 * ORDER_DOES_NOT_BELONG_TO_THIS_CENTER = 1 nel caso si cambia centro dentro un dettaglio ordine o alert
 * CHANGED_PASSWORD_OK = 2 cambio password andato a bun fine
 * CHANGED_PASSWORD_KO = 3 cambio password non andato a bun fine
 * SENT_ALERT_OK = 4 alert inviato con successo
 * SENT_ALERT_KO = 5 alert non inviato
 * GENERIC_ERROR = 6 in caso di errore generico
 * ORDER_NOT_EXIST = 7 quando si va in un dettaglio ordine con un id che non esiste
 * SENT_REPORTING_OK = 8 sengalazione ordine andata a buon fine
 * SENT_SUSPEND_READY_OK = 9 il torna in approntamento è andato a buon fine
 * SENT_READY_OK = 10 ordine pronto è andato a buon fine
 * SENT_ACCEPT_ORDER_OK = 11 accetta ordine è andato a buon fine
 * SENT_DECLINE_ORDER_OK = 12 rifiuta ordine è andato a buon fine
 * SEARCH_RESULT_VOID = 13; se una ricerca torna 0 elementi
 *
 *
 * se mandiamo un id negativo viene cancellato il messaggio rimasto con quell'id;
 */

export class InnerMessage {
	static INVOICING_REFERENCE_OK: string = 'INVOICING_REFERENCE_OK';
	static DELETE_ALL: string = 'DELETE_ALL';
	static ORDER_DOES_NOT_BELONG_TO_THIS_CENTER: string = 'ORDER_DOES_NOT_BELONG_TO_THIS_CENTER';
	static CHANGED_PASSWORD_OK: string = 'CHANGED_PASSWORD_OK';
	static CHANGED_PASSWORD_KO: string = 'CHANGED_PASSWORD_KO';
	static SENT_ALERT_OK: string = 'SENT_ALERT_OK';
	static SENT_ALERT_OK_BUT_ATTACHMENTS_KO: string = 'SENT_ALERT_OK_BUT_ATTACHMENTS_KO';
	static SENT_ALERT_KO: string = 'SENT_ALERT_KO';
	static SENT_ALERT_WITH_ATTACHMENTS_KO: string = 'SENT_ALERT_WITH_ATTACHMENTS_KO';
	static ALL_ALERT_UPDATED_KO: string = 'ALL_ALERT_UPDATED_KO';
	static GENERIC_ERROR: string = 'GENERIC_ERROR';
	static ORDER_NOT_EXIST: string = 'ORDER_NOT_EXIST';
	static SENT_REPORTING_OK: string = 'SENT_REPORTING_OK';
	static SENT_REPORTING_KO: string = 'SENT_REPORTING_KO';
	static SENT_SUSPEND_READY_OK: string = 'SENT_SUSPEND_READY_OK';
	static SENT_SUSPEND_READY_KO: string = 'SENT_SUSPEND_READY_KO';
	static SENT_READY_OK: string = 'SENT_READY_OK';
	static SENT_READY_KO: string = 'SENT_READY_KO';
	static SENT_ACCEPT_ORDER_OK: string = 'SENT_ACCEPT_ORDER_OK';
	static SENT_ACCEPT_ORDER_OK_BUT_NOT_ATTACHED: string = 'SENT_ACCEPT_ORDER_OK_BUT_NOT_ATTACHED';
	static SENT_ACCEPT_ORDER_KO: string = 'SENT_ACCEPT_ORDER_KO';
	static SENT_DECLINE_ORDER_OK: string = 'SENT_DECLINE_ORDER_OK';
	static SEARCH_ORDER_RESULT_VOID: string = 'SEARCH_ORDER_RESULT_VOID';
	static SEARCH_INVOICE_RESULT_VOID: string = 'SEARCH_INVOICE_RESULT_VOID';
	static SEARCH_TASK_RESULT_VOID: string = 'SEARCH_TASK_RESULT_VOID';
	static SEARCH_ALERT_RESULT_VOID: string = 'SEARCH_ALERT_RESULT_VOID';
	static SERVER_ERROR: string = 'SERVER_ERROR';
	static ORDER_OR_ALERT_DOES_NOT_BELONG_TO_THIS_CENTER: string = 'ORDER_OR_ALERT_DOES_NOT_BELONG_TO_THIS_CENTER';
	static ORDER_DELIVERY_SAVED_BUT_NOT_VALID: string = 'ORDER_DELIVERY_SAVED_BUT_NOT_VALID';
	static FILE_ATTACHED_SAVED_OK: string = 'FILE_ATTACHED_SAVED_OK';
	static FILE_ATTACHED_SAVED_KO: string = 'FILE_ATTACHED_SAVED_KO';
	static FILE_ATTACHED_REMOVED_OK: string = 'FILE_ATTACHED_REMOVED_OK';
	static FILE_ATTACHED_REMOVED_KO: string = 'FILE_ATTACHED_REMOVED_KO';
	static FILE_DOWNLOAD_KO: string = 'FILE_DOWNLOAD_KO';
	static FILE_NOT_FOUND: string = 'FILE_NOT_FOUND';
	static FILE_EXPORT_OK: string = 'FILE_EXPORT_OK';
	static DIGITAL_SIGN_STATUS_NOT_VALID: string = 'DIGITAL_SIGN_STATUS_NOT_VALID';
	static DIGITAL_SIGN_ABORT_OK: string = 'DIGITAL_SIGN_ABORT_OK';
	static DIGITAL_SIGN_STATUS_ERROR: string = 'DIGITAL_SIGN_STATUS_ERROR';

	static ORDER_DELIVERY_DRIVER_DOCUMENTS_MISSING: string = 'ORDER_DELIVERY_DRIVER_DOCUMENTS_MISSING';
	static ORDER_DELIVERY_DELEGATE_DOCUMENTS_MISSING: string = 'ORDER_DELIVERY_DELEGATE_DOCUMENTS_MISSING';

	static ORDER_ADC_GENERATE_KO: string = 'ORDER_ADC_GENERATE_KO';

	static ORDER_LETTER_GENERATE_OK: string = 'ORDER_LETTER_GENERATE_OK';
	static ORDER_LETTER_GENERATE_KO: string = 'ORDER_LETTER_GENERATE_KO';

	static ORDERS_DETAILS_CERTIFICATE_ATTACHED_SAVED_OK: string = 'ORDERS_DETAILS_CERTIFICATE_ATTACHED_SAVED_OK';
	static ORDERS_DETAILS_CERTIFICATE_ATTACHED_SAVED_KO: string = 'ORDERS_DETAILS_CERTIFICATE_ATTACHED_SAVED_KO';
	static DIGITAL_SIGN_GENERIC_ERROR: string = 'DIGITAL_SIGN_GENERIC_ERROR';
	static DIGITAL_SIGN_WRONG_OTP_OR_PIN: string = 'DIGITAL_SIGN_WRONG_OTP_OR_PIN';

	static APPOINTMENT_UPDATE_OK: string = 'APPOINTMENT_UPDATE_OK';
	static APPOINTMENT_UPDATE_KO: string = 'APPOINTMENT_UPDATE_KO';
	static APPOINTMENT_CREATE_OK: string = 'APPOINTMENT_CREATE_OK';
	static APPOINTMENT_CREATE_KO: string = 'APPOINTMENT_CREATE_KO';
	static SEARCH_APPOINTMENT_RESULT_VOID: string = 'SEARCH_APPOINTMENT_RESULT_VOID';

	static APPOINTMENT_DKC_UPDATE_OK: string = 'APPOINTMENT_DKC_UPDATE_OK';
	static APPOINTMENT_DKC_UPDATE_OK_SMS_KO: string = 'APPOINTMENT_DKC_UPDATE_OK_SMS_KO';
	static APPOINTMENT_DKC_UPDATE_KO: string = 'APPOINTMENT_DKC_UPDATE_KO';
	static APPOINTMENT_DKC_UPDATE_OK_SMS_KO_EMAIL_KO: string = 'APPOINTMENT_DKC_UPDATE_OK_SMS_KO_EMAIL_KO';
	static APPOINTMENT_DKC_UPDATE_OK_SMS_OK_EMAIL_KO: string = 'APPOINTMENT_DKC_UPDATE_OK_SMS_OK_EMAIL_KO';
	static APPOINTMENT_DKC_UPDATE_OK_SMS_KO_EMAIL_OK: string = 'APPOINTMENT_DKC_UPDATE_OK_SMS_KO_EMAIL_OK';

	static UPDATE_TAG_OK: string = 'UPDATE_TAG_OK';
	static UPDATE_TAG_KO: string = 'UPDATE_TAG_KO';
	static UPDATE_THREAD_OK: string = 'UPDATE_THREAD_OK';
	static UPDATE_THREAD_KO: string = 'UPDATE_THREAD_KO';
	static SEARCH_THREAD_RESULT_VOID: string = 'SEARCH_THREAD_RESULT_VOID';
	static DELETED_THREAD_OK: string = 'DELETED_THREAD_OK';

	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_KO: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_KO';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_STATUS_NOT_UPDATED: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_STATUS_NOT_UPDATED';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_DS_ERROR: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_DS_ERROR';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_WD_ERROR: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_WD_ERROR';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_FM_ERROR: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_FM_ERROR';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_ACCEPT_ERROR: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_ACCEPT_ERROR';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_FE_GENERIC_ERROR: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_FE_GENERIC_ERROR';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_UNKNOW_TYPE: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_UNKNOW_TYPE';
	static DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_VOID_SIGN_RESPONSE: string = 'DIGITAL_SIGN_SIGNER_PROCESS_COMPLETED_OK_BUT_VOID_SIGN_RESPONSE';
	static DIGITAL_SIGN_SIGN_AND_ACCEPT_PROCESS_GENERIC_KO: string = 'DIGITAL_SIGN_SIGN_AND_ACCEPT_PROCESS_GENERIC_KO';


	static ORDER_DETAILS_DELIVERY_ERROR_404: string = 'ORDER_DETAILS_DELIVERY_ERROR_404';

	static CC_REPORT_DETAILS_LIST_SAVE_OK: string = 'CC_REPORT_DETAILS_LIST_SAVE_OK';
	static CC_REPORT_DETAILS_LIST_SAVE_KO: string = 'CC_REPORT_DETAILS_LIST_SAVE_KO';
	static CC_REPORT_DETAILS_LIST_CLOSED_OK: string = 'CC_REPORT_DETAILS_LIST_CLOSED_OK';
	static CC_REPORT_DETAILS_LIST_CLOSED_KO: string = 'CC_REPORT_DETAILS_LIST_CLOSED_KO';
	static CC_REPORT_DETAILS_LIST_DELETED_OK: string = 'CC_REPORT_DETAILS_LIST_DELETED_OK';
	static CC_REPORT_DETAILS_LIST_DELETED_KO: string = 'CC_REPORT_DETAILS_LIST_DELETED_KO';


	static CC_SEARCH_CONTRACT_RESULT_VOID: string = 'CC_SEARCH_CONTRACT_RESULT_VOID';

	static CC_SPO_IMPORT_CONTRACT_FROM_ESB_OK: string = 'CC_SPO_IMPORT_CONTRACT_FROM_ESB_OK';
	static CC_SPO_IMPORT_CONTRACT_FROM_ESB_OK_BUT_APPOINTMENT_NOT_CONFIRMED: string = 'CC_SPO_IMPORT_CONTRACT_FROM_ESB_OK_BUT_APPOINTMENT_NOT_CONFIRMED';
	static CC_SPO_IMPORT_CONTRACT_FROM_ESB_KO: string = 'CC_SPO_IMPORT_CONTRACT_FROM_ESB_KO';

	static CC_SPO_SET_CONTRACT_READY_FOR_SURVEY_OK: string = 'CC_SPO_SET_CONTRACT_READY_FOR_SURVEY_OK';
	static CC_SPO_SET_CONTRACT_READY_FOR_SURVEY_KO: string = 'CC_SPO_SET_CONTRACT_READY_FOR_SURVEY_KO';

	static CC_CONTRACT_NOT_EXIST: string = 'CC_CONTRACT_NOT_EXIST';
	static CC_CONTRACT_STATUS_NOT_VALID_FOR_SURVEY: string = 'CC_CONTRACT_STATUS_NOT_VALID_FOR_SURVEY';

	static CC_REPORT_DETAILS_INVALID_LIST_EXTERNAL_DAMAGES: string = 'CC_REPORT_DETAILS_INVALID_LIST_EXTERNAL_DAMAGES';
	static CC_REPORT_DETAILS_INVALID_LIST_INTERNAL_DAMAGES: string = 'CC_REPORT_DETAILS_INVALID_LIST_INTERNAL_DAMAGES';
	static CC_REPORT_DETAILS_INVALID_SURVEY_NOTES: string = 'CC_REPORT_DETAILS_INVALID_SURVEY_NOTES';
	static CC_REPORT_DETAILS_INVALID_TIRE_CONDITIONS: string = 'CC_REPORT_DETAILS_INVALID_TIRE_CONDITIONS';


	static CC_SPO_SAVE_CUSTOMER_OK: string = 'CC_SPO_SAVE_CUSTOMER_OK';
	static CC_SPO_SAVE_CUSTOMER_KO: string = 'CC_SPO_SAVE_CUSTOMER_KO';
	static CC_SPO_SAVE_CUSTOMER_OK_BUT_NOT_VALID: string = 'CC_SPO_SAVE_CUSTOMER_OK_BUT_NOT_VALID';
	static CC_SPO_DOCUMENT_MISSING: string = 'CC_SPO_DOCUMENT_MISSING';
	static CC_SPO_CERTIFICATE_GENERATE_KO: string = 'CC_SPO_CERTIFICATE_GENERATE_KO';

	static CC_IMPORT_CONTRACT_FROM_ESB_KO: string = 'CC_IMPORT_CONTRACT_FROM_ESB_KO';

	static CC_SPO_CERTIFICATE_ATTACHED_OK: string = 'CC_SPO_CERTIFICATE_ATTACHED_OK';
	static CC_SPO_CERTIFICATE_ATTACHED_KO: string = 'CC_SPO_CERTIFICATE_ATTACHED_KO';

	static CC_SPO_CONTRACT_DECLINED_OK: string = 'CC_SPO_CONTRACT_DECLINED_OK';
	static CC_SPO_CONTRACT_DECLINED_KO: string = 'CC_SPO_CONTRACT_DECLINED_KO';
	static CC_SPO_CONTRACT_IS_WITHOUT_SURVEY: string = 'CC_SPO_CONTRACT_IS_WITHOUT_SURVEY';

	static CC_ALD_IMPORT_CONTRACTS_OK: string = 'CC_ALD_IMPORT_CONTRACTS_OK';
	static CC_ALD_IMPORT_CONTRACTS_KO: string = 'CC_ALD_IMPORT_CONTRACTS_KO';
	static CC_ALD_CLOSED_CONTRACTS_OK: string = 'CC_ALD_CLOSED_CONTRACTS_OK';
	static CC_ALD_CLOSED_CONTRACTS_OK_BUT_NOT_ALL: string = 'CC_ALD_CLOSED_CONTRACTS_OK_BUT_NOT_ALL';
	static CC_ALD_CLOSED_CONTRACTS_KO: string = 'CC_ALD_CLOSED_CONTRACTS_KO';

	static CC_SUCCESS_GENERAL_NOTE_CREATED: string = 'CC_SUCCESS_GENERAL_NOTE_CREATED';
	static CC_GENERAL_OPERATION_SUCCESS: string = 'CC_GENERAL_OPERATION_SUCCESS';

	static CC_ALD_IMPORT_CONTRACTS_ERROR_CONVERT_TO_BASE64: string = 'CC_ALD_IMPORT_CONTRACTS_ERROR_CONVERT_TO_BASE64';
	static CC_ALD_IMPORT_CONTRACTS_KO_MAX_NUM: string = 'CC_ALD_IMPORT_CONTRACTS_KO_MAX_NUM';

	static CC_SPO_CONTRACT_NDS_CLOSED_OK: string = 'CC_SPO_CONTRACT_NDS_CLOSED_OK';
	static CC_SPO_CONTRACT_NDS_CLOSED_KO: string = 'CC_SPO_CONTRACT_NDS_CLOSED_KO';

	static CC_DKC_SURVEYOR_SEARCH_RESULT_VOID: string = 'CC_DKC_SURVEYOR_SEARCH_RESULT_VOID';
	static CC_DKC_SURVEYOR_CREATE_OK: string = 'CC_DKC_SURVEYOR_CREATE_OK';
	static CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_PROFILE: string = 'CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_PROFILE';
	static CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_CROSS: string = 'CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_CROSS';
	static CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_MODULE: string = 'CC_DKC_SURVEYOR_CREATE_OK_BUT_NOT_ASSOCIATE_MODULE';
	static CC_DKC_SURVEYOR_CREATE_GENERAL_KO: string = 'CC_DKC_SURVEYOR_CREATE_GENERAL_KO';
	static CC_DKC_SURVEYOR_CREATE_USER_ALREADY_EXIST_KO: string = 'CC_DKC_SURVEYOR_CREATE_USER_ALREADY_EXIST_KO';
	static CC_DKC_SURVEYOR_UPDATE_USER_OK: string = 'CC_DKC_SURVEYOR_UPDATE_USER_OK';
	static CC_DKC_SURVEYOR_UPDATE_USER_KO: string = 'CC_DKC_SURVEYOR_UPDATE_USER_KO';

	static CC_DK_BO_CONTRACT_DETAIL_NOVALIDDATA: string = 'CC_DK_BO_CONTRACT_DETAIL_NOVALIDDATA';
	static CC_DK_BO_CONTRACT_DETAIL_CLAIMS_ERROR: string = 'CC_DK_BO_CONTRACT_DETAIL_CLAIMS_ERROR';
	static CC_DK_BO_CONTRACT_CURRENCY_NOVALIDDATA: string = 'CC_DK_BO_CONTRACT_CURRENCY_NOVALIDDATA';
	static CC_DK_BO_LETTER_GENERATE_KO: string = 'CC_DK_BO_LETTER_GENERATE_KO';
	static CC_DK_BO_LETTER_GENERATE_OK: string = 'CC_DK_BO_LETTER_GENERATE_OK';

	static CC_DKC_COMMODITY_NOTFOUND: string = 'CC_DKC_COMMODITY_NOTFOUND';
	static CC_DKC_CONTRACT_ALREADY_IMPORTED: string = 'CC_DKC_CONTRACT_ALREADY_IMPORTED';
	static CC_DKO_SURVEYOR_ACCESSORIES_KO: string = 'CC_DKO_SURVEYOR_ACCESSORIES_KO';

	static CLAIMS_SEARCH_APPROPRIATION_RESULT_VOID: string = 'CLAIMS_SEARCH_APPROPRIATION_RESULT_VOID';
	static CLAIMS_APPROPRIATION_ALREADY_SEQUESTERED: string = 'CLAIMS_APPROPRIATION_ALREADY_SEQUESTERED';
	static CLAIMS_APPROPRIATION_CREATE_OK: string = 'CLAIMS_APPROPRIATION_CREATE_OK';
	static CLAIMS_APPROPRIATION_CREATE_KO: string = 'CLAIMS_APPROPRIATION_CREATE_KO';
	static CLAIMS_APPROPRIATION_CLAIM_NOT_FOUND: string = 'CLAIMS_APPROPRIATION_CLAIM_NOT_FOUND';
	static CLAIMS_APPROPRIATION_FILES_ADD_OK: string = 'CLAIMS_APPROPRIATION_FILES_ADD_OK';


	static CLAIMS_PRACTICE_CAR_CREATE_OK: string = 'CLAIMS_PRACTICE_CAR_CREATE_OK';
	static CLAIMS_SEARCH_PRACTICE_CAR_RESULT_VOID: string = 'CLAIMS_SEARCH_PRACTICE_CAR_RESULT_VOID';


	static CLAIMS_APPROPRIATION_PRACTICE_CAR_PLATE_NOT_FOUND: string = 'CLAIMS_APPROPRIATION_PRACTICE_CAR_PLATE_NOT_FOUND';
	static CLAIMS_APPROPRIATION_PRACTICE_CAR_PLATE_CHANGE_STATUS_OK: string = 'CLAIMS_APPROPRIATION_PRACTICE_CAR_PLATE_CHANGE_STATUS_OK';
	static CLAIMS_APPROPRIATION_PRACTICE_CAR_DELETE_FILE_OK: string = 'CLAIMS_APPROPRIATION_PRACTICE_CAR_DELETE_FILE_OK';
	static CLAIMS_APPROPRIATION_PRACTICE_CAR_DELETE_FILE_KO: string = 'CLAIMS_APPROPRIATION_PRACTICE_CAR_DELETE_FILE_KO';
	static CLAIMS_ENTITY_ALREADY_ENABLED: string = 'CLAIMS_ENTITY_ALREADY_ENABLED';

	static CLAIMS_SEARCH_CLAIMS_RESULT_VOID: string = 'CLAIMS_SEARCH_CLAIMS_RESULT_VOID';
	static CLAIMS_SEARCH_COUNTERPARTY_RESULT_VOID: string = 'CLAIMS_SEARCH_COUNTERPARTY_RESULT_VOID';
	static REPAIR_SUFFIX: string = '_REPAIR';
	static CLAIMS_DRAFT_CREATED: string = 'CLAIMS_DRAFT_CREATED';
	static CLAIMS_DRAFT_UPDATED: string = 'CLAIMS_DRAFT_UPDATED';
	static CLAIMS_CREATED: string = 'CLAIMS_CREATED';
	static CLAIMS_UPDATED: string = 'CLAIMS_UPDATED';
	static CLAIMS_ENTITY_CREATED: string = 'CLAIMS_ENTITY_CREATED';
	static CLAIMS_ENTITY_UPDATED: string = 'CLAIMS_ENTITY_UPDATED';
	static CLAIMS_ENTITY_ENABLED: string = 'CLAIMS_ENTITY_ENABLED';
	static CLAIMS_ENTITY_DISABLED: string = 'CLAIMS_ENTITY_DISABLED';
	static CLAIMS_ENTITY_DELETED: string = 'CLAIMS_ENTITY_DELETED';
	static CLAIMS_IMPORT_FILE_OK: string = 'CLAIMS_IMPORT_FILE_OK';
	static CLAIMS_IMPORT_FILE_KO: string = 'CLAIMS_IMPORT_FILE_KO';
	static CLAIMS_GENERIC_RESULT_VOID: string = 'CLAIMS_GENERIC_RESULT_VOID';
	static CLAIMS_AUTHORITY_LINK_DISABLED: string = 'CLAIMS_AUTHORITY_LINK_DISABLED';
	static CLAIMS_AUTHORITY_LINK_ENABLED: string = 'CLAIMS_AUTHORITY_LINK_ENABLED';
	static CLAIMS_COMUNICATION_SUCCESS: string = 'CLAIMS_COMUNICATION_SUCCESS';
	static CLAIMS_CUSTOMER_STATUS_UPDATED: string = 'CLAIMS_CUSTOMER_STATUS_UPDATED';
	static CLAIMS_EXPORT_THEFTS: string = 'CLAIMS_EXPORT_THEFTS';
	static CLAIMS_EXPORT_CLAIMS: string = 'CLAIMS_EXPORT_CLAIMS';
	static CLAIMS_GENERIC_ERROR: string = 'CLAIMS_GENERIC_ERROR';


	static BLACK_CUSTOMER: string = 'BLACK_CUSTOMER';
	static AUTHORITY_NOT_SAVED: string = 'AUTHORITY_NOT_SAVED';
	static AUTHORITY_SAVED: string = 'AUTHORITY_SAVED';
	static AUTHORITY_QUOTATION_NOT_SAVED: string = 'AUTHORITY_QUOTATION_NOT_SAVED';
	static AUTHORITY_QUOTATION_SAVED: string = 'AUTHORITY_QUOTATION_SAVED';
	static AUTHORITY_RESULT_VOID: string = 'AUTHORITY_RESULT_VOID';
	static AUTHORITY_CONTRACT_NOT_ACTIVE: string = 'AUTHORITY_CONTRACT_NOT_ACTIVE';
	static AUTHORITY_OPERATION_SAVED: string = 'AUTHORITY_OPERATION_SAVED';
	static AUTHORITY_CARGLASS_AUTHORIZED: string = 'AUTHORITY_CARGLASS_AUTHORIZED';
	static AUTHORITY_CARGLASS_CLAIMS_LINKED: string = 'AUTHORITY_CARGLASS_CLAIMS_LINKED';
	static AUTHORITY_CARGLASS_REJECTED: string = 'AUTHORITY_CARGLASS_REJECTED';
	static AUTHORITY_WARRANTY_UPDATED: string = 'AUTHORITY_WARRANTY_UPDATED';
	static AUTHORITY_SUCCESS_IMPORT: string = 'AUTHORITY_SUCCESS_IMPORT'
	static AUTHORITY_WORKING_RESULT_VOID: string = 'AUTHORITY_WORKING_RESULT_VOID';
	
	// Authority performance
	// nessun risultato - controllare negli archivi
	static AUTHORITY_DOSSIERS_RESULT_VOID_CHECK_ARCHIVE     : string = 'AUTHORITY_DOSSIERS_RESULT_VOID_CHECK_ARCHIVE';
	static AUTHORITY_WORKINGS_RESULT_VOID_CHECK_ARCHIVE     : string = 'AUTHORITY_WORKINGS_RESULT_VOID_CHECK_ARCHIVE';
	static AUTHORITY_GLASSES_RESULT_VOID_CHECK_ARCHIVE      : string = 'AUTHORITY_GLASSES_RESULT_VOID_CHECK_ARCHIVE';
	static AUTHORITY_OPERATIONS_RESULT_VOID_CHECK_ARCHIVE   : string = 'AUTHORITY_OPERATIONS_RESULT_VOID_CHECK_ARCHIVE';
	static AUTHORITY_APPOINTMENTS_RESULT_VOID_CHECK_ARCHIVE : string = 'AUTHORITY_APPOINTMENTS_RESULT_VOID_CHECK_ARCHIVE';


	static VOID_EMAIL_LIST: string = 'VOID_EMAIL_LIST';

	static SEARCH_MOVEMENTS_RESULT_VOID: string = 'SEARCH_MOVEMENTS_RESULT_VOID';
	static TYRE_CODE_PLATE_NOT_FOUND: string = 'TYRE_CODE_PLATE_NOT_FOUND';
	static TYRE_REQUEST_SUCCESSFULLY_TAKEN: string = 'TYRE_REQUEST_SUCCESSFULLY_TAKEN';
	static TYRE_REQUEST_SUCCESSFULLY_COMPLETED: string = 'TYRE_REQUEST_SUCCESSFULLY_COMPLETED';
	static TYRE_TRANSFER_SUCCESSFULLY_ACCEPTED: string = 'TYRE_TRANSFER_SUCCESSFULLY_ACCEPTED';
	static TYRE_TRANSFER_LOCKED_ALD_INSTRUCTION: string = 'TYRE_TRANSFER_LOCKED_ALD_INSTRUCTION';
	static TYRE_TRANSFER_REJECT: string = 'TYRE_TRANSFER_REJECT';
	static TYRE_SUCCESSFULLY_REGISTERED: string = 'TYRE_SUCCESSFULLY_REGISTERED';
	static TYRE_SUCCESSFULLY_REJECT: string = 'TYRE_SUCCESSFULLY_REJECT';
	static TYRE_ERROR_DOWNLOAD_DDT: string = 'TYRE_ERROR_DOWNLOAD_DDT';
	static TYRE_ERROR_DOWNLOAD_CUSTOMER_RELEASE: string = 'TYRE_ERROR_DOWNLOAD_CUSTOMER_RELEASE';
	static TYRE_ERROR_DOWNLOAD_LABEL: string = 'TYRE_ERROR_DOWNLOAD_LABEL';
	static TYRE_ERROR_DELIVERY_TYRE_INCOMPLETE: string = 'TYRE_ERROR_DELIVERY_TYRE_INCOMPLETE';
	static TYRE_ERROR_UNLOCK: string = 'TYRE_ERROR_UNLOCK';
	static TYRE_SUCCESS_UNLOCK: string = 'TYRE_SUCCESS_UNLOCK';
	static TYRE_ERROR_FORCE_CLOSE: string = 'TYRE_ERROR_FORCE_CLOSE';
	static TYRE_SUCCESS_FORCE_CLOSE: string = 'TYRE_SUCCESS_FORCE_CLOSE';
	static TYRE_ERROR_WITHDRAWN: string = 'TYRE_ERROR_WITHDRAWN';
	static TYRE_SUCCESS_WITHDRAWN: string = 'TYRE_SUCCESS_WITHDRAWN';
	static TYRE_DELIVERY_LATE: string = 'TYRE_DELIVERY_LATE';
	static TYRE_EXPIRING: string = 'TYRE_EXPIRING';
	static TYRE_DISPOSED: string = 'TYRE_DISPOSED';
	static TYRES_DISPOSED: string = 'TYRES_DISPOSED';

	static SEARCH_CONTRACT_RESULT_VOID: string = 'SEARCH_CONTRACT_RESULT_VOID';

	static SEARCH_TYRES_RESULT_VOID: string = 'SEARCH_TYRES_RESULT_VOID';

	static UC_CREATE_APPOINTMENT_KO: string = 'UC_CREATE_APPOINTMENT_KO';
	static UC_PROCEDURE_LOAD_ERROR: string = 'UC_PROCEDURE_LOAD_ERROR';
	static UC_PAPER_SIGNATURE_UPLOAD_OK: string = 'UC_PAPER_SIGNATURE_UPLOAD_OK';
	static UC_DAMAGES_KO: string = 'UC_DAMAGES_KO';

	static SEARCH_LOGISTIC_TRANSFER_RESULT_VOID: string = 'SEARCH_LOGISTIC_TRANSFER_RESULT_VOID';
	static SEARCH_LOGISTIC_SEGMENT_RESULT_VOID: string = 'SEARCH_LOGISTIC_SEGMENT_RESULT_VOID';
	static SEARCH_LOGISTIC_CHANNEL_RESULT_VOID: string = 'SEARCH_LOGISTIC_CHANNEL_RESULT_VOID';
	static SEARCH_LOGISTIC_TRANSPORTER_RESULT_VOID: string = 'SEARCH_LOGISTIC_TRANSPORTER_RESULT_VOID';
	static SEARCH_LOGISTIC_RULES_RESULT_VOID: string = 'SEARCH_LOGISTIC_RULES_RESULT_VOID';
	static SEARCH_LOGISTIC_SATURATION_RESULT_VOID: string = 'SEARCH_LOGISTIC_SATURATION_RESULT_VOID';
	static SEARCH_LOGISTIC_REQUEST_RESULT_VOID: string = 'SEARCH_LOGISTIC_REQUEST_RESULT_VOID';
	static LOGISTIC_TRANSFER_WITHDRAWAL_FAILURE: string = 'LOGISTIC_TRANSFER_WITHDRAWAL_FAILURE';
	static LOGISTIC_TRANSFER_DELIVERY_FAILURE: string = 'LOGISTIC_TRANSFER_DELIVERY_FAILURE';
	static LOGISTIC_TRANSFER_REFUSED: string = 'LOGISTIC_TRANSFER_REFUSED';
	static LOGISTIC_TRANSFER_REFUSED_CHANNEL_FORNITORE_INTEGRATO: string = 'LOGISTIC_TRANSFER_REFUSED_CHANNEL_FORNITORE_INTEGRATO';
	static LOGISTIC_VEHICLE_NOT_FOUND: string = 'LOGISTIC_VEHICLE_NOT_FOUND';
	static LOGISTIC_ADMIN_PENALTIES_SUCCESSFUL_SENT: string = 'LOGISTIC_ADMIN_PENALTIES_SUCCESSFUL_SENT';
	static LOGISTIC_ASSIGNMENT_ERROR: string = 'LOGISTIC_ASSIGNMENT_ERROR';
	static LOGISTIC_ASSIGNMENT_SUCCESS: string = 'LOGISTIC_ASSIGNMENT_SUCCESS';
	static LOGISTIC_ASSIGNMENT_DELIVERY_ERROR: string = 'LOGISTIC_ASSIGNMENT_DELIVERY_ERROR';
	static LOGISTIC_DDT_VOID: string = 'LOGISTIC_DDT_VOID';
	static SEARCH_LOGISTIC_ASR_VOID: string = 'SEARCH_LOGISTIC_ASR_VOID';
	static SEARCH_LOGISTIC_ASR_SERVICE_VOID: string = 'SEARCH_LOGISTIC_ASR_SERVICE_VOID';
	static SEARCH_LOGISTIC_ASR_VEHICLE_ENTRY_RESULT_VOID: string = 'SEARCH_LOGISTIC_ASR_VEHICLE_ENTRY_RESULT_VOID';
	static SEARCH_LOGISTIC_ASR_VEHICLE_CHECKOUT_RESULT_VOID: string = 'SEARCH_LOGISTIC_ASR_VEHICLE_CHECKOUT_RESULT_VOID';
	static SEARCH_LOGISTIC_ASR_VEHICLE_STOCK_RESULT_VOID: string = 'SEARCH_LOGISTIC_ASR_VEHICLE_STOCK_RESULT_VOID';
	static SEARCH_LOGISTIC_ASR_VEHICLE_DELIVERED_RESULT_VOID: string = 'SEARCH_LOGISTIC_ASR_VEHICLE_DELIVERED_RESULT_VOID';
	static LOGISTIC_IMPORT_ERROR: string = 'LOGISTIC_IMPORT_ERROR';
	static LOGISTIC_IMPORT_SUCCESS: string = 'LOGISTIC_IMPORT_SUCCESS';
	static LOGISTIC_EXPORT_SUCCESS: string = 'LOGISTIC_EXPORT_SUCCESS';
	static ASSIGN_INVOLEMENT_LEVEL_TRANSFER: string = 'ASSIGN_INVOLEMENT_LEVEL_TRANSFER';
	static TRANSFER_ASSIGNED: string = 'TRANSFER_ASSIGNED';
	static FLOTTA_POOL_DOUBLE_KEYS_ERROR: string = 'DOUBLE_KEYS_ERROR';
	static SUPER_USER_GATEWAY_1002: string = 'SUPER_USER_GATEWAY_1002';

	static CHANGE_USER_1054: string = 'CHANGE_USER_1054';
	static CHANGE_USER_1055: string = 'CHANGE_USER_1055';
	static CHANGE_USER_1056: string = 'CHANGE_USER_1056';
	static CHANGE_USER_1058: string = 'CHANGE_USER_1058';
	
	static SUCCESS_UPLOADED_ATTACHMENT: string = 'SUCCESS_UPLOADED_ATTACHMENT';
	static SUCCESS_DELETED_ATTACHMENT: string = 'SUCCESS_DELETED_ATTACHMENT';
	static OPS_C_E_STATO_UN_PROBLEMA: string = 'OPS_C_E_STATO_UN_PROBLEMA';
	static PROCESSATO: string = 'PROCESSATO';
	static EMAIL_INVIATA_CORRETTAMENTE: string = 'EMAIL_INVIATA_CORRETTAMENTE';
	static DATA_MODIFICATA_CORRETTAMENTE: string = 'DATA_MODIFICATA_CORRETTAMENTE';
	static IMPOSSIBILE_RECUPERARE_I_DATI_DELLA_PRATICA: string = 'IMPOSSIBILE_RECUPERARE_I_DATI_DELLA_PRATICA';
	static MODIFICA_EFFETTTUATA_CON_SUCCESSO: string = 'MODIFICA_EFFETTTUATA_CON_SUCCESSO';
	static EMAIL_NON_INVIATA_CORRETTAMENTE: string = 'EMAIL_NON_INVIATA_CORRETTAMENTE';
	static ANDARE_IN_PIANIFICAZIONE: string = 'ANDARE_IN_PIANIFICAZIONE';
	static EVIDENZE_FORZATE: string = 'EVIDENZE_FORZATE';
	static AFFIDO_FORZATO: string = 'AFFIDO_FORZATO';
	static PRATICHE_ASSEGNATE_CORRETTAMENTE: string = 'PRATICHE_ASSEGNATE_CORRETTAMENTE';

	static MIDDLEWARE_CLIENT_9013: string = 'MIDDLEWARE_CLIENT_9013'

	static TYPE_SUCCESS: string = 'success';
	static TYPE_WARNING: string = 'warning';
	static TYPE_ERROR: string = 'error';
	static TYPE_INFO: string = 'info';
	static DELAY: number = 20000;

	static FLOTTA_POOL_STATE_ERROR_CONTRACT: 'FP_ERROR_CONTRACT';
	static FLOTTA_POOL_IMPORT_PROCESS_STARTED: 'FP_IMPORT_PROCESS_STARTED';

	static SEARCH_LOGISTIC_PARAMETERS_RESULT_VOID: string = 'SEARCH_LOGISTIC_PARAMETERS_RESULT_VOID';
	static SEARCH_LOGISTIC_PARAMETERS_ASR_RESULT_VOID: string = 'SEARCH_LOGISTIC_PARAMETERS_ASR_RESULT_VOID';
	
	static LOGISTICS_8001: string = 'LOGISTICS_8001';
	static LOGISTICS_8002: string = 'LOGISTICS_8002';
	static LOGISTICS_8003: string = 'LOGISTICS_8003';
	static LOGISTICS_8004: string = 'LOGISTICS_8004';
	static LOGISTICS_8005: string = 'LOGISTICS_8005';
	static LOGISTICS_8006: string = 'LOGISTICS_8006';
	static LOGISTICS_8007: string = 'LOGISTICS_8007';
	static LOGISTICS_8008: string = 'LOGISTICS_8008';
	static LOGISTICS_8011: string = 'LOGISTICS_8011';
	
	static BOOKINGS_12014: string = 'BOOKINGS_12014';
	static BOOKINGS_12015: string = 'BOOKINGS_12015';
	static BOOKINGS_12016: string = 'BOOKINGS_12016';
	static BOOKINGS_12017: string = 'BOOKINGS_12017';

	static FILE_DOWNLOAD_OK: string = 'FILE_DOWNLOAD_OK';
	static SHARED__MSG_SUCESS__IMPORT_FILE_OK_REPORT_EMAIL: string = 'SHARED__MSG_SUCESS__IMPORT_FILE_OK_REPORT_EMAIL';


	type: string;
	autoDeleteEnable: boolean;
	id: string;
	state: string;
	parameter: any;
	removing: boolean;
	keepAlive: boolean;
	autoDeleteDelay: number;

	constructor(id: string, type: string, parameter: any, autoDeleteEnable?: boolean, keepAlive?: boolean, autoDeleteDelay?: number) {
		this.id = id;
		this.type = type;
		this.autoDeleteEnable = autoDeleteEnable;
		this.parameter = parameter;
		this.removing = false;
		this.keepAlive = keepAlive || false;
		this.autoDeleteDelay = autoDeleteDelay || InnerMessage.DELAY;
	}
}
